import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Api } from '../../libs/api'
import Item from './item'
import Alink from 'estimate_list/libs/alink'
import { arrayShuffle } from 'estimate_list/utils/array'

const Stdpc = () => {
    const [list, setList] = useState([])
    const [tab, setTab] = useState('')

    useEffect(() => {
        getStdpc()
    }, [])

    const getStdpc = () => {
        Api.getStdpc().then(rst => {
            if (rst.data.success) {
                const data = rst.data.result.cate?.[0]?.child[0].child || []
                setTab(data[0]?.cate_id || '')
                setList(data)
            }
        })
    }

    const onClickTab = cate => () => {
        setTab(cate)
    }

    return (
        <>
            {list.length > 0 && (
                <Layout listLength={list.length}>
                    <ul>
                        {list.map((v, _) => {
                            return (
                                <li key={v.cate_id} className="list">
                                    <button
                                        className={`topTab ${tab === v.cate_id ? 'active' : ''}`}
                                        onClick={onClickTab(v.cate_id)}
                                    >
                                        {v.cate_name}
                                    </button>
                                    {tab === v.cate_id && (
                                        <div className="contents">
                                            <div className="top">
                                                <div className="subject">
                                                    <span>
                                                        {v.cate_name.substr(0, v.cate_name.indexOf('PC'))}{' '}
                                                        <b>표준PC</b>
                                                    </span>
                                                    <Alink href={`${process.env.REACT_APP_STDPC_URL}/list/2010000000#${v.cate_id}`} className="moreBtn">
                                                        + 더보기
                                                    </Alink>
                                                </div>
                                            </div>
                                            <div className="products">
                                                {/* 셔플 기능추가/ 최대4개 노출 */}
                                                {v.stdpclist.length !== 0 ? (
                                                    <ul>
                                                        {arrayShuffle(v.stdpclist).slice(0, 4).map((vv) => (
                                                            <Item key={vv.item_id} itemData={vv} />
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <NoItem>상품 준비중 입니다.</NoItem>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                </Layout>
            )}
        </>
    )
}

const LayoutContentHeight = 384
const ButtonTabHeight = 46

const Layout = styled.div`
    position: relative;
    height: ${LayoutContentHeight + ButtonTabHeight}px;
    margin: 25px 0 0;

    * {
        box-sizing: border-box
    }
    .list {
        &:first-child {
            .topTab {
                border-left: 1px solid #e5e5e5
            }
        }
        .topTab {
            float: left;
            background: #f2f2f2;
            border: 1px solid #e5e5e5;
            border-left: 0;
            border-bottom: 1px solid #418ded;
            width: calc(100% / ${props => props.listLength});
            height: ${ButtonTabHeight}px;
            line-height: ${ButtonTabHeight}px;
            font-size: 14px;
            font-weight: 700;
            color: #666;

            &.active {
                background: #fff;
                border: 1px solid #418ded;
                border-left: 1px solid #418ded;
                border-bottom: 1px solid #dae9fb;
            }

            &:hover {
                background: #fff;
            }
        }
    }
    .contents {
        position: absolute;
        top: ${ButtonTabHeight}px;
        width: 100%;
        height: ${LayoutContentHeight}px;
        padding: 25px 30px;
        border: 1px solid #418ded;
        border-top: 0;

        .top {
            display: flex;
            margin: 0 0 20px;
        }
        .subject {
            margin-right: auto;

            span {
                vertical-align: top;
                display: inline-block;
                font-size: 20px;
                font-weight: 700;
                color: #333;
                line-height: 30px;

                b {
                    color: #666
                }
            }
            a {
                margin: 0 0 0 10px;
                vertical-align: top;
                display: inline-block;
                color: #666;
                line-height: 30px;

                &:hover {
                    color: #418ded
                }
            }
        }
        .box_tab {
            button {
                width: 107px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #e5e5e5;
                background: #fff;
                font-weight: 700;
                color: #666;

                &:not(:first-child) {
                    border-left: 1px solid transparent;
                }
                &:hover {
                    background: #f2f2f2
                }
                &.active {
                    border: 1px solid #418ded;
                    border-left: 1px solid #418ded;
                    color: #418ded;
                    background: #fff;
                }
            }
        }
        .page {
            margin: 0 0 0 20px;
            font-size: 14px;
            font-weight: 700;

            .current {
                color: #418ded;
            }
            .prev,
            .next {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 30px;
                border: 1px solid #e5e5e5;
                color: #999;
                font-weight: 400;
                font-size: 0;
                cursor: pointer;

                &:before {
                    font-size: 15px;
                }
                &:hover {
                    color: #418ded;
                    border-color: #418ded;
                }
            }
            .prev {
                margin: 0 8px 0 0
            }
            .next {
                margin: 0 0 0 8px
            }
        }
    }
    .products {
        li {
            float: left;
            width: 23%;

            & + li {
                margin: 0 0 0 2.6%
            }
            & > a {
                display: block;

                &:hover {
                    .thumb {
                        border: 1px solid #418ded
                    }
                }
            }
        }
        .thumb {
            border: 1px solid transparent;
            width: 202px;
            height: auto;

            img {
                width: 100%;
                height: 100%;
            }
        }
        .title {
            margin: 10px 0 0;
            height: 36px;
            line-height: 18px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .price {
            margin: 10px 0 0;
            color: #333;
            line-height: 18px;

            strong {
                margin: 0 1px 0 5px;
                font-size: 18px;
            }
        }
    }
`

const NoItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    height: 267px;
`

export default Stdpc



// WEBPACK FOOTER //
// ./src/estimate_list/components/stdpc/Stdpc.js